import { createAction } from '@reduxjs/toolkit';

export const REMOVE_DRAWER_PRODUCTS = 'REMOVE_DRAWER_PRODUCTS';

export const removeDrawerProducts = createAction(
    REMOVE_DRAWER_PRODUCTS,
    () => ({ payload: [] }),
);
